import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {CreateEntityButton} from 'entities/tariff';

interface ICreateHttpMonitorButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const CreateHttpMonitorButton: React.FC<ICreateHttpMonitorButtonProps> = ({onClick, disabled}) => (
    <CreateEntityButton ariaLabel={t`Добавить сайт`} onClick={onClick} disabled={disabled}>
        <Trans id="button.add.site" message="Добавить сайт" />
    </CreateEntityButton>
);

export default CreateHttpMonitorButton;
